module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "6em"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h3', [_vm._v("Welcome")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Manage your Agent Services")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('hr'), _vm._v(" "), (_vm.is_agent) ? _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]) : _c('div', {
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', [_c('div', {
    staticClass: "card",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#242323"
    }
  }, [_vm._v("Turn on Agent Services")]), _vm._v(" "), _c('p', [_vm._v("An Agent business account would be created for you. You will get to earn from\r\n                  service charges paid when creating shop accounts, managing shops, making orders and more")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "background-color": "rgb(41, 122, 245)",
      "border-radius": "18px",
      "color": "#ffffff"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('premiumMember')
      }
    }
  }, [_vm._v("\r\n                Yes, Turn on my Agent Services")]), _vm._v(" "), _c('br'), _c('br')])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])])])])]), _vm._v(" "), _c('component-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding": "0 2em"
    }
  }, [_c('h5', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Total earned today:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-6 w-any",
    staticStyle: {
      "border-right": "solid 3px #eee"
    }
  }, [_c('h5', [_vm._v("Shop Accounts")]), _vm._v(" "), _c('p', [_vm._v("0")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 w-any"
  }, [_c('h5', [_vm._v("Successful Orders")]), _vm._v(" "), _c('p', [_vm._v("0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-active"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Create a Shop Account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Product")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Make Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charges ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage your Account ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Create a Shop Account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Upload Product")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Make Orders")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Service Charges ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card card-blosq card-na"
  }, [_c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Manage your Account ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fas fa-angle-right"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08bee094"}!./src/pages/AgentServices/template.html
// module id = 495
// module chunks = 0